import { fetcher } from '@commenda/utils';

export async function cancelEnvelope(
  envelopeId: string,
  reason?: string
): Promise<Response> {
  return fetcher(`e-signature/envelopes/${envelopeId}/cancel`, {
    method: 'POST',
    body: reason ? { reason } : {},
  });
}
